import { cn } from "@reactive-resume/utils";
import { useEffect, useRef, useState } from "react";

type Props = {
  score: number;
  scoreKey?: string;
  thickness?: string;
};

export const ScoreLoader = ({ score, scoreKey, thickness = "2" }: Props) => {
  const [currentWidth, setCurrentWidth] = useState(0);
  const progressBarRef = useRef<HTMLDivElement>(null);

  const animateProgress = (start: number, end: number) => {
    let width = start;
    const step = (end - start) / 100; // Adjust for animation speed
    const animate = () => {
      if (width < end) {
        width += step;
        setCurrentWidth(width);
        requestAnimationFrame(animate);
      } else {
        setCurrentWidth(end);
      }
    };
    requestAnimationFrame(animate);
  };

  useEffect(() => {
    if (progressBarRef.current) {
      const startWidth = currentWidth;
      animateProgress(startWidth, score);
    }
  }, [score]);

  return (
    <div
      id="progressWrapper"
      className="box3D hover:box3D-hover dark:box3Ddark dark:hover:box3Ddark-hover mr-3 grow rounded-lg p-0.5"
    >
      <div
        ref={progressBarRef}
        id={`progressBar_${scoreKey}`}
        className={cn(
          `p-${thickness} rounded-lg bg-gradient-to-r from-[#8fd3f4] to-[#84fab0] text-white`,
          Number(score) <= 60 && "bg-gradient-to-r from-[#fda085] to-[#f6d365]",
        )}
        style={{ width: `${currentWidth}%` }}
      />
    </div>
  );
};
